import { createFileRoute } from "@tanstack/react-router";
import { SalesPulse } from "@/components/SalesPulse/SalesPulse";

export const Route = createFileRoute("/_authenticated/sales/pulse/")({
  component: SalesPulse,
  staticData: { page: "pulse" },
});
